import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
// import util from 'util';
import constClass from '../../Constants/Constants';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router';
import moment from 'moment';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { useHistory, generatePath } from 'react-router-dom';
import QRCode from "react-qr-code";
import { v4 as uuidv4 } from 'uuid';
import Select from 'react-select';

const Event = (props) => {
  const { user } = props;
  const { siteId, mallId } = useParams();
  const [mallLineLiffUrlData, setMallLineLiffUrlData] = useState(null);
  const [eventData, setEventData] = useState(null);
  const [lockData, setLockData] = useState(false);
  const { addToast } = useToasts();
  const history = useHistory();
  const refs = useRef({});
  const [ticketData, setTicketData] = useState(null);
  const [checkinPointCampaignData, setCheckinPointCampaignData] = useState(null);

  const PAGE_SIZE = 10;

  const [values, setValues] = useState({
    event_id: null,
    event_name: '',
    point_give: null,
    point_campaign_id: null,
    ticket_id: null,
    event_uuid: null,
    validity_start_date: null,
    validity_end_date: null,
    event_lon: '',
    event_lat: '',
    ticket_expire_date: moment().format('YYYYMMDD'),
    point_expire_date: moment().format('YYYYMMDD'),
    bonus_type: constClass.BONUS_TYPE.POINT,
    acquire_setting: constClass.ACQUIRE_SETTING_TYPE.ONETIME,
  });

  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const refreshData = useCallback(async () => {
    const mallLineLiffUrl = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/mall/${siteId}/${mallId}`)).data.line_liff_url;
    setMallLineLiffUrlData(mallLineLiffUrl);

    const jwt = localStorage.getItem('jwt');
    var eventData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/event/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setEventData(eventData);

    var ticketData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ticket/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setTicketData(ticketData.filter(item => item.ticket_type === constClass.TICKET_TYPE.FREE));

    var checkinPointCampaignData = (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/checkin_point_campaign/${siteId}/${mallId}`, {
      headers: {
        Authorization: `Bearer ${jwt}`,
      }
    })).data;
    setCheckinPointCampaignData(checkinPointCampaignData);

  }, [siteId, mallId]);

  /* 編集ボタン押下 */
  const handleUpdateClick = (data) => {
    const temp = data;

    temp.event_name = temp.event_name ? temp.event_name : '';
    temp.point_give = temp.point_give ? temp.point_give : null;
    temp.validity_start_date = temp.validity_start_date ? moment(temp.validity_start_date, 'YYYYMMDD') : null;
    temp.validity_end_date = temp.validity_end_date ? moment(temp.validity_end_date, 'YYYYMMDD') : null;
    setValues(temp);
  }

  const handleNoTimeLimitClick = () => {
    setValues({
      ...values,
      validity_start_date: new Date(),
      validity_end_date: new Date(9999, 11, 31),
    });
  }

  /* RESETボタン押下 */
  const handleResetClick = () => {
    setValues({
      event_id: null,
      event_name: '',
      point_give: null,
      point_campaign_id: null,
      ticket_id: null,
      event_uuid: null,
      validity_start_date: null,
      validity_end_date: null,
      event_lon: '',
      event_lat: '',
      ticket_expire_date: moment().format('YYYYMMDD'),
      point_expire_date: moment().format('YYYYMMDD'),
      bonus_type: constClass.BONUS_TYPE.POINT,
      acquire_setting: constClass.ACQUIRE_SETTING_TYPE.ONETIME,
    });
  }

  /* DB更新 */
  const handleRegistClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!data.event_name) {
      window.alert('イベント名を入力してください。');
      return;
    }
    if (data.event_name.length > 50) {
      window.alert('イベント名は、50文字以内で入力してください。');
      return;
    }
    if ((data.bonus_type === constClass.BONUS_TYPE.TICKET || data.bonus_type === constClass.BONUS_TYPE.BOTH) && !data.ticket_id) {
      window.alert('配布クーポンを選択してください。');
      return;
    }
    if ((data.bonus_type === constClass.BONUS_TYPE.TICKET || data.bonus_type === constClass.BONUS_TYPE.BOTH) && !data.ticket_expire_date) {
      window.alert('クーポン有効期限を入力してください。');
      return;
    }
    if ((data.bonus_type === constClass.BONUS_TYPE.POINT || data.bonus_type === constClass.BONUS_TYPE.BOTH) && !data.point_expire_date && data.acquire_setting !== constClass.ACQUIRE_SETTING_TYPE.DAILYONCE) {
      window.alert('ポイント有効期限を入力してください。');
      return;
    }
    if ((data.bonus_type === constClass.BONUS_TYPE.POINT || data.bonus_type === constClass.BONUS_TYPE.BOTH) && !data.point_give) {
      window.alert('付与ポイントを入力してください。');
      return;
    }
    if (!data.validity_start_date) {
      window.alert('有効期間開始日を入力してください。');
      return;
    }
    if (!data.validity_end_date) {
      window.alert('表示期間終了日を入力してください。');
      return;
    }
    if (isNaN(Number(data.event_lat))) {
      window.alert('緯度は数字を入力してください。');
      return;
    }
    if (Number(data.event_lat) > 90 || Number(data.event_lat) < -90) {
      window.alert('緯度は90度以内で入力してください。');
      return;
    }
    if (isNaN(Number(data.event_lon))) {
      window.alert('経度は数字を入力してください。');
      return;
    }
    if (Number(data.event_lon) > 180 || Number(data.event_lon) < -180) {
      window.alert('経度は180度以内で入力してください。');
      return;
    }
    if ((data.event_lat !== '' && data.event_lat !== null) && (data.event_lon === '' || data.event_lon === null)) {
      window.alert('緯度を入力した場合は経度を入力してください。');
      return;
    }
    if ((data.event_lon !== '' && data.event_lon !== null) && (data.event_lat === '' || data.event_lat === null)) {
      window.alert('経度を入力した場合は緯度を入力してください。');
      return;
    }
    var params = data;
    params.ins_name = user.userId;
    params.upd_name = user.userId;
    params.site_id = siteId;
    params.mall_id = mallId;
    params.event_lat = (data.event_lat !== '' && data.event_lat !== null) ? Number(data.event_lat) : null;
    params.event_lon = (data.event_lon !== '' && data.event_lon !== null) ? Number(data.event_lon) : null;
    if (data.event_uuid === null) params.event_uuid = uuidv4();
    if (data.ticket_id) params.ticket_id = Number(params.ticket_id);
    if (data.bonus_type === constClass.BONUS_TYPE.TICKET) {
      params.point_give = null;
      params.point_expire_date = null;
    }
    if (data.bonus_type === constClass.BONUS_TYPE.POINT) {
      params.ticket_id = null;
      params.ticket_expire_date = null;
    }
    if (data.acquire_setting === constClass.ACQUIRE_SETTING_TYPE.DAILYONCE) {
      params.point_expire_date = null;
    }

    let res;
    try {
      setLockData(true);
      if (params.event_id === null || params.event_id === "") {
        res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/event/`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      } else {
        res = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/event/${params.event_id}`, params, {
          headers: {
            Authorization: `Bearer ${jwt}`
          }
        });
      }
    } catch (err) {
      console.log(err);
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (!res) {
      } else if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('登録しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const checkinPointCampaignOptions = checkinPointCampaignData ? checkinPointCampaignData.map(point_campaign => ({
    value: point_campaign.point_campaign_id,
    label: point_campaign.point_campaign_name,
  })) : [];

  const handleDownloadQRCode = (data) => {
    const svg = document.getElementById(`qr-svg-${data.event_id}`);
    if (!svg) return;

    const serializer = new XMLSerializer();
    const svgString = serializer.serializeToString(svg);

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const img = new Image();
    img.onload = () => {
      canvas.width = img.width + 20; // 余白を追加
      canvas.height = img.height + 20; // 余白を追加
      ctx.fillStyle = 'white'; // 余白の色を指定
      ctx.fillRect(0, 0, canvas.width, canvas.height); // 余白を描画
      ctx.drawImage(img, 10, 10); // QRコードを描画
      // canvas.width = img.width;
      // canvas.height = img.height;
      // ctx.drawImage(img, 0, 0);

      const url = canvas.toDataURL('image/png');
      const a = document.createElement('a');
      a.href = url;
      a.download = data.event_id + '_' + data.event_name + '.png';
      a.click();
    };
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgString)));
  };

  // QRコードを表示するコンポーネント
  const QRPrintComponent = React.forwardRef(({ data }, ref) => (
    <div ref={ref} className="d-flex flex-column align-items-center justify-content-center">
      <div className='align-self-center'>
        <div className='text-center align-self-center mt-4'>イベントID: {data.event_id}</div>
        <div className='text-center align-self-center mt-4'>イベント名: {data.event_name}</div>
        <div className='d-flex justify-content-center align-items-center mt-4'>
          <QRCode
            id={`qr-svg-${data.event_id}`}
            className="qr-detail-img"
            size={500}
            value={`${mallLineLiffUrlData ? mallLineLiffUrlData : process.env.FRONTEND_URL}?page=${constClass.EVENT}&event_uuid=${data.event_uuid}`}
          />
        </div>
      </div>
    </div>
  ));

  // 二次元コードボタン
  const renderTwoDimensionalCodeButton = (data) => {
    const ref = refs.current[data.event_id];
    return (
      <React.Fragment>
        <button
          type="button"
          className="btn btn-primary mx-1"
          onClick={() => handleDownloadQRCode(data)}
        >
          二次元コード
        </button>
        <div style={{ display: 'none' }}>
          <QRPrintComponent ref={ref} data={data} />
        </div>
      </React.Fragment>
    );
  }

  /* DB削除 */
  const handleDeleteClick = async (data) => {
    const jwt = localStorage.getItem('jwt');
    if (!window.confirm(`イベントマスタ[${data.event_id}:${data.event_name}]を削除します。よろしいですか？`)) {
      return;
    }
    const params = {
      site_id: siteId,
      event_id: data.event_id,
      upd_date: data.upd_date
    };
    let res;
    try {
      setLockData(true);
      res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/event/delete/`, params, {
        headers: {
          Authorization: `Bearer ${jwt}`,
        }
      });
    } catch (err) {
      if (err.response.data !== null) {
        addToast(err.response.data.msg, { appearance: 'error', autoDismiss: true });
      } else {
        addToast(err.response, { appearance: 'error', autoDismiss: true });
      }
    } finally {
      if (res.data.error) {
        addToast(res.data.message, { appearance: 'error', autoDismiss: true });
      } else {
        addToast('削除しました。', { appearance: 'success', autoDismiss: true });
        await refreshData();
      }
      setLockData(false);
      handleResetClick();
    }
  }

  const renderUpdateButton = (data) => {
    return (
      <button
        className={`btn btn-primary mx-1`}
        onClick={() => handleUpdateClick(data)}>
        編集
      </button>
    )
  }

  const renderRegistButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.event_name === ''}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleRegistClick(data)}>
        登録
      </button>
    )
  }

  const renderDeleteButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.event_id === null}
        className={`btn btn-primary mx-1 w-50`}
        onClick={() => handleDeleteClick(data)}>
        削除
      </button>
    )
  }

  const renderResetButton = () => {
    return (
      <button type="button"
        disabled={false}
        className={`btn btn-primary mx-1 w-50 text-nowrap text-center align-self-center`}
        onClick={() => handleResetClick()}>
        リセット
      </button>
    )
  }

  const renderNoTimeLimitButton = () => {
    return (
      <button type="button"
        disabled={lockData}
        className={`btn btn-outline-dark text-black mx-1 w-50 text-nowrap text-center align-self-center`}
        onClick={() => handleNoTimeLimitClick()}>
        期限なし
      </button>
    )
  }

  const renderNotificationManagementButton = (data) => {
    return (
      <button type="button"
        disabled={lockData || data.event_id === null}
        className={`btn btn-primary mx-1`}
        onClick={() => history.push(generatePath(`${props.match.path}eventinfo/${data.event_id}`, { siteId: props.match.params.siteId, mallId: props.match.params.mallId }))}
      >
        お知らせ管理
      </button>
    )
  }

  const handleChange = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? (target.checked ? constClass.FLAG.ON : constClass.FLAG.OFF) : target.value;
    const name = target.name;
    setValues({ ...values, [name]: value });
  }

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const handleChangeDate = (name, value) => {
    if (name === "validity_end_date") {
      // 終了日は23:59:59にする
      value = moment(value).endOf('day').toDate();
    } else {
      // 開始日は00:00:00にする
      value = moment(value).startOf('day').toDate();
    }
    setValues({ ...values, [name]: value });
  }

  const renderInput = () => {
    return (
      <div className="mx-1">
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>イベントID</span>
          </div>
          <div className="col-2 text-center align-self-center">
            <input type="text" className="form-control" name="event_id" defaultValue={values.event_id} placeholder="新規" readOnly />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>イベント名</span>
          </div>
          <div className="col-5 text-center align-self-center">
            <input type="text" className="form-control" name="event_name" value={values.event_name} onChange={handleChange} />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="acquire_setting">獲得設定</label>
          </div>
          <div className="col-5">
            <select className="form-control" id="acquire_setting" name="acquire_setting" value={values.acquire_setting} onChange={handleChange}>
              <option key={constClass.ACQUIRE_SETTING_TYPE_NAME.ONETIME} value={constClass.ACQUIRE_SETTING_TYPE.ONETIME}>{constClass.ACQUIRE_SETTING_TYPE_NAME.ONETIME}</option>              
              <option key={constClass.ACQUIRE_SETTING_TYPE_NAME.DAILYONCE} value={constClass.ACQUIRE_SETTING_TYPE.DAILYONCE}>{constClass.ACQUIRE_SETTING_TYPE_NAME.DAILYONCE}</option>
            </select>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <label htmlFor="bonus_type">ボーナス区分</label>
          </div>
          <div className="col-5">
            <select className="form-control" id="bonus_type" name="bonus_type" value={values.bonus_type} onChange={handleChange}>
              <option key={constClass.BONUS_TYPE_NAME.POINT} value={constClass.BONUS_TYPE.POINT}>{constClass.BONUS_TYPE_NAME.POINT}</option>
              <option key={constClass.BONUS_TYPE_NAME.TICKET} value={constClass.BONUS_TYPE.TICKET}>{constClass.BONUS_TYPE_NAME.TICKET}</option>
              <option key={constClass.BONUS_TYPE_NAME.BOTH} value={constClass.BONUS_TYPE.BOTH}>{constClass.BONUS_TYPE_NAME.BOTH}</option>
            </select>
          </div>
        </div>
        {(values.bonus_type === constClass.BONUS_TYPE.POINT || values.bonus_type === constClass.BONUS_TYPE.BOTH) &&
          <React.Fragment>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="point_give">付与ポイント</label>
              </div>
              <div className="col-5 align-self-center">
                <input type="text" className="form-control" name="point_give" id="point_give" value={values.point_give || ''} onChange={handleChange}></input>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="point_expire_date">ポイント有効期限日</label>
              </div>
              <div className="col-5 text-center align-self-center">
                <input type="text" className="form-control" name="point_expire_date" value={values.acquire_setting === constClass.ACQUIRE_SETTING_TYPE.DAILYONCE ? "" : values.point_expire_date ? values.point_expire_date.replace(/-/g, "") : ""} onChange={handleChange} placeholder="YYYYMMDD" disabled={values.acquire_setting === constClass.ACQUIRE_SETTING_TYPE.DAILYONCE} />
              </div>
              {values.acquire_setting === constClass.ACQUIRE_SETTING_TYPE.DAILYONCE && 
                <span>※獲得設定が「1日1回」の場合、ポイントの有効期限は翌年の12月31日までとなります</span>
              }
            </div>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="point_campaign_id">適用ポイントキャンペーン</label>
              </div>
              <div className="col-5 align-self-center">
                <Select
                  options={checkinPointCampaignOptions}
                  onChange={option => setValues({ ...values, point_campaign_id: option ? option.value : null })}
                  placeholder="- 選択 -"
                  isClearable={true}
                  value={checkinPointCampaignOptions.find(option => option.value === values.point_campaign_id) || null}
                />
              </div>
            </div>
          </React.Fragment>
        }
        {(values.bonus_type === constClass.BONUS_TYPE.TICKET || values.bonus_type === constClass.BONUS_TYPE.BOTH) &&
          <React.Fragment>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="ticket_id">配布クーポン</label>
              </div>
              <div className="col-5 align-self-center">
                <select className="form-control" id="ticket_id" name="ticket_id" value={values.ticket_id || ''} onChange={handleChange}>
                  <option value="">- 選択 -</option>
                  {ticketData && ticketData.map((ticket) => (
                    <option key={ticket.ticket_id} value={ticket.ticket_id}>
                      {ticket.ticket_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-2 text-center align-self-center">
                <label htmlFor="ticket_expire_date">クーポン有効期限日</label>
              </div>
              <div className="col-5 text-center align-self-center">
                <input type="text" className="form-control" name="ticket_expire_date" value={values.ticket_expire_date ? values.ticket_expire_date.replace(/-/g, "") : ""} onChange={handleChange} placeholder="YYYYMMDD" />
              </div>
            </div>
          </React.Fragment>
        }
        <div className="row mb-4">
          <div className="col-2 pt-1 pr-0 text-center align-self-center">
            <span>チェックインの有効期間</span>
          </div>
          <div className="col-3 text-center">
            <DatePicker className="custom-select text-left w-100"
              locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'validity_start_date'} name={'validity_start_date'}
              popperPlacement='bottom'
              selected={values.validity_start_date
                ? (moment.isMoment(values.validity_start_date)
                  ? values.validity_start_date.toDate()
                  : (isNaN(new Date(values.validity_start_date)) ? null : new Date(values.validity_start_date)))
                : null
              }
              onChange={date => handleChangeDate("validity_start_date", date ? date : null)}
              placeholderText="- 選択 -"
              autoComplete='off'
              isClearable={true}
              onFocus={(e) => e.target.blur()}
            />
          </div>
          <div className="col-1 text-center">～</div>
          <div className="col-3 text-center">
            <DatePicker className="custom-select text-left w-100"
              locale="ja" dateFormat="yyyy/MM/dd" monthsShown="1" id={'validity_end_date'} name={'validity_end_date'}
              popperPlacement='bottom'
              selected={values.validity_end_date
                ? (moment.isMoment(values.validity_end_date)
                  ? values.validity_end_date.toDate()
                  : (isNaN(new Date(values.validity_end_date)) ? null : new Date(values.validity_end_date)))
                : null}
              onChange={date => handleChangeDate("validity_end_date", date ? date : null)}
              placeholderText="- 選択 -"
              autoComplete='off'
              isClearable={true}
              onFocus={(e) => e.target.blur()}
            />
          </div>
          <div className="col-3 text-center">
            {renderNoTimeLimitButton()}
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>緯度</span>
          </div>
          <div className="col-8 text-center align-self-center">
            <input type="text" className="form-control" name="event_lat" value={values.event_lat || ''} onChange={handleChange} placeholder="緯度(33前後)をXX.XXXXXX形式で入力してください" />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-2 text-center align-self-center">
            <span>経度</span>
          </div>
          <div className="col-8 text-center align-self-center">
            <input type="text" className="form-control" name="event_lon" value={values.event_lon || ''} onChange={handleChange} placeholder="経度(130前後)をXXX.XXXXXX形式で入力してください" />
          </div>
        </div>
        <div className="row pb-4">
          <div className="col-3 text-center">
            {renderRegistButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderDeleteButton(values)}
          </div>
          <div className="col-3 text-center">
            {renderResetButton(values)}
          </div>
        </div>
      </div>
    );
  }

  const renderList = () => {

    eventData.forEach((data) => {
      if (!refs.current[data.event_id]) {
        refs.current[data.event_id] = React.createRef();
      }
    });

    const filteredData = eventData.filter(data =>
      !searchKeyword || data.event_name.includes(searchKeyword)
    );
    const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
    const pagedData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

    return (
      <div className="row mb-3 p-0 mt-2">
        <div className="col-12 mb-2">
          <div className="row">
            <input
              type="text"
              className="col-4 form-control"
              placeholder="イベント名で絞り込み"
              value={searchKeyword}
              onChange={e => { setSearchKeyword(e.target.value); setCurrentPage(1); }}
            />
          </div>
        </div>
        <div className="col-12 p-0">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="small text-muted">{filteredData.length}件中 {Math.min((currentPage - 1) * PAGE_SIZE + 1, filteredData.length)}〜{Math.min(currentPage * PAGE_SIZE, filteredData.length)}件表示</span>
            {totalPages > 1 && (
              <nav>
                <ul className="pagination pagination-sm mb-0">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>‹</button>
                  </li>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                      <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                  ))}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>›</button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
          <table className="table table-bordered table-striped">
            <thead className={`table-info`}>
              <tr>
                <td className="text-center align-middle">
                  イベントID
                </td>
                <td className="text-center align-middle">
                  イベント名
                </td>
                <td className="text-center align-middle">
                  チェックインの有効期間
                </td>
                <td className="text-center align-middle">
                  処理
                </td>
              </tr>
            </thead>
            <tbody>
              {pagedData.map((data, idx) => (
                <tr key={data.event_id}>
                  {/* イベントID */}
                  <td className="text-center align-middle">
                    {data.event_id}
                  </td>
                  {/* イベント名 */}
                  <td className="text-center align-middle">
                    {data.event_name}
                  </td>
                  {/* チェックインの有効期間 */}
                  <td className="text-center align-middle">
                    {moment(data.validity_start_date).format('YYYY/MM/DD')}&nbsp;&nbsp;～&nbsp;&nbsp;{moment(data.validity_end_date).format('YYYY/MM/DD')}
                  </td>
                  {/* 処理 */}
                  <td className="text-center align-middle text-nowrap">
                    {renderUpdateButton(data)}
                    {renderTwoDimensionalCodeButton(data)}
                    {renderNotificationManagementButton(data)}
                  </td>
                </tr>
              ))
              }
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {eventData === null && <div className="row"><div className="col-12">読み込み中・・・</div></div>}
      {eventData !== null && (renderList())}
      {renderInput()}
    </div>
  )
}

export default Event;